export default "__VITE_ASSET__7f0d0fe7__"